import styled from '@emotion/styled'

export const ModalImageWrapper = styled.figure`
  display: flex;
  justify-content: center;
`
